module.exports = __webpack_public_path__ + "img/white.4a0ed36b.png";